// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__1zwux"};